var _defineProperty = require("/Users/apple/Documents/Personal/vibe-main/velocityUAE/website/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _module$exports;

var path = require("path");

var PACKAGE = require("../package.json");

module.exports = (_module$exports = {
  root: path.resolve(__dirname, "../"),
  entryPath: path.resolve(__dirname, "../", "src/index.js"),
  outputPath: path.resolve(__dirname, "../", "v" + PACKAGE.version),
  demoPath: path.resolve(__dirname, "../", "demo/index.js"),
  templatePath: path.resolve(__dirname, "../", "src/index.html"),
  imgsFolder: "imgs",
  fontsFolder: "fonts",
  cssFolder: "css",
  jsFolder: "js"
}, _defineProperty(_module$exports, "imgsFolder", "imgs"), _defineProperty(_module$exports, "fontsFolder", "fonts"), _defineProperty(_module$exports, "cssFolder", "css"), _defineProperty(_module$exports, "jsFolder", "js"), _defineProperty(_module$exports, "imgsPath", "https://goselljslib.b-cdn.net/v1.3/imgs/"), _defineProperty(_module$exports, "fontsPath", "https://goSellJSLib.b-cdn.net/fonts/"), _defineProperty(_module$exports, "cssPath", "https://goSellJSLib.b-cdn.net/css/"), _defineProperty(_module$exports, "serverPath", "https://checkout.payments.tap.company/api"), _defineProperty(_module$exports, "framePath", "https://checkout.payments.tap.company/"), _module$exports);